// content-card
import { Link } from 'react-router-dom';

import { Row, Col } from 'antd';
import { Card } from 'antd';

const { Meta } = Card;

export default function ContentCardMedium(props) {
  
  const data = props.data;

  return (
    <>
      <div className="" >
        
        <Card
          hoverable
          className="rounded-wd"
          cover={
            <div className="media-square rounded-wd" 
              style={{borderBottomLeftRadius:0, borderBottomRightRadius:0}}>
              <img className="" src={data.link} alt={data.memo}></img>
            </div>
          }
        >
          <Meta 
            className="" 
            title={ <></> } 
            description={
              <>
              
              <p className="text-lead text-color-main m-0 text-bold">{data.name}</p>
              <p className="text-color-tone m-0">{data.memo}</p>
              </>
            } 
          />
        </Card>

      </div>
  
    </>
    )
  }